import React from 'react';
import { Refrigerator, Wind, Flame, Speaker, Fan, Microwave, Package } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { services, companyInfo } from '../data/mock';

const iconMap = {
  Refrigerator: Refrigerator,
  WashingMachine: Package,
  Wind: Wind,
  Microwave: Microwave,
  Fan: Fan,
  Flame: Flame,
  Speaker: Speaker
};

export const Services = () => {
  return (
    <section id="servicios" className="py-20 bg-gradient-to-b from-white to-blue-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">
            Nuestros Servicios
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600">
            Ofrecemos reparación profesional y mantenimiento para todo tipo de electrodomésticos.
            Servicio rápido, confiable y con garantía.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon] || Package;
            return (
              <Card 
                key={service.id}
                className="group hover:shadow-2xl transition-all duration-300 border-2 border-transparent hover:border-blue-200 bg-white overflow-hidden"
                style={{
                  animationDelay: `${index * 100}ms`
                }}
              >
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={service.image} 
                    alt={`Reparación de ${service.title} - Servicio técnico profesional TecnoService Medellín`}
                    title={`${service.title} - TecnoService Medellín`}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-blue-900/90 to-transparent"></div>
                  <div className="absolute bottom-4 left-4">
                    <div className="bg-white p-3 rounded-lg shadow-lg">
                      <IconComponent className="w-6 h-6 text-blue-700" />
                    </div>
                  </div>
                </div>
                
                <CardHeader>
                  <CardTitle className="text-xl text-blue-900 group-hover:text-blue-700 transition-colors">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                
                <CardContent>
                  <CardDescription className="text-gray-600 leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Call to action */}
        <div className="text-center mt-16">
          <p className="text-lg text-gray-700 mb-4">
            ¿No encuentras el servicio que necesitas?
          </p>
          <a 
            href={`https://wa.me/${companyInfo.whatsapp}?text=${encodeURIComponent('Hola, necesito información sobre un servicio.')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-700 font-semibold hover:text-blue-800 underline underline-offset-4 transition-colors"
          >
            Contáctanos y te ayudaremos
          </a>
        </div>
      </div>
    </section>
  );
};
